export default {
  headerContent: {
    title: 'Quick Sigorta Kefalet Sigortası Ücretleri',
    slogan: "Kefalet Sigortası'nı işin uzmanına bırak.",
    btnTitle: 'KEFALET SİGORTASI TEKLİFİ AL'
  },
  crossPageContent: {
    mainTitle: 'Quick Sigorta Kefalet Sigortası',
    description: {
      title: 'Quick Sigorta Kefalet Sigortası Nedir? ',
      content: [
        'Kefalet sigortası, kamu ihalelerinde bankalar tarafından düzenlenmekte olan teminat mektubuna alternatif yaratan ve banka kredi limitlerini etkilemeyen, özel sektör için önemli ve yeni bir üründür.'
      ]
    },
    subContent: {
      title: 'Quick Sigorta Kefalet Sigortası Teminatları Nelerdir?',
      content: [
        {
          paragraph: 'Quick Sigorta kefalet sigortası kapsamında;',
          subList: [
            'İhaleye Katılım Teminatı.',
            'Performans Teminatı',
            'İmalat, Bakım Ve Onarım Teminatı.',
            'Sözleşme Teminatı',
            'Gümrük Ve Mahkeme Teminatı'
          ]
        },
        {
          paragraph: 'Olmak üzere 5 adet teminat sunulmaktadır.',
          subList: null
        }
      ]
    }
  },
  getPrice: {
    mainTitle: 'Kefalet Sigortası Teklifi Nasıl Alınır?',
    campaigns: [
      {
        id: 1,
        name: 'Kefalet Sigortası',
        assurance: 'Ek Teminatlı',
        price: '+50 TL'
      },
      {
        id: 2,
        name: 'Kefalet Sigortası',
        assurance: 'Standart Teminatlı',
        price: '+50 TL'
      },
      {
        id: 3,
        name: 'Kefalet Sigortası',
        assurance: 'Zorunlu Teminatlı',
        price: '+50 TL'
      },
      {
        id: 4,
        name: 'Ferdi Kaza Sigortası',
        assurance: 'Ek Teminatlı',
        price: '+50 TL'
      }
    ]
  },
  faqTitle: 'Quick Sigorta Kefalet Sigortası Hakkında Merak Edilenler',
  faqTitleDesc: 'Her gün yayınlanan güvenilir bilgilere kolay erişim.',
  questions: []
}
